<template>
<div class="ui three top attached steps">
  <div class="step" :class="[{active:step == 1}, {completed:step > 1}]">
    <i class="truck icon"></i>
    <div class="content">
      <div class="title">Pasūtījuma informācija</div>
      <div class="description">Norādi piegādes adresi un datumu</div>
    </div>
  </div>
  <div class="step" :class="[{active:step == 2}, {disabled:step < 2}, {completed:step > 2}]">
    <i class="payment icon"></i>
    <div class="content">
      <div class="title">Apmaksa</div>
      <div class="description">Izvēlies apmaksas veidu</div>
    </div>
  </div>
  <!-- if status > 2 then assume that order is confirmed and waiting execution -->
  <div class="step" :class="[{active:step == 3}, {disabled:step < 3}, {completed:confirmed>2}]">
    <i class="info icon"></i>
    <div class="content">
      <div class="title">Apstiprinājums</div>
      <div class="description">Pārbaudi pasūtījuma detaļas</div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ["step", "confirmed"]
}
</script>



// WEBPACK FOOTER //
// CartSteps.vue?52aebb88